import { createInstance, dateReviver } from '@/api';
import { ProductGroup, PublicationClient } from '@/api/frontoffice/clients';
import { i18n } from '@/i18n';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';

export interface ProductGroupOptionsStoreState {
    productGroups?: ProductGroup[];
    loading: boolean;
}

export const client = new PublicationClient('', createInstance(), dateReviver);

// The list comes from the FrontOffice API rather than the BackOffice one: the publications page is
// open to a dataleverancier, who has no configuration rights.
export const useProductGroupOptionsStore = defineStore('publications-product-group-options-store', {
    state: (): ProductGroupOptionsStoreState => ({
        productGroups: [],
        loading: false
    }),
    getters: {},
    actions: {
        // Feeds the product group dropdown, so the list is fetched once and kept.
        async getProductGroups() {
            this.loading = true;

            if (!this.productGroups?.length) {
                try {
                    this.productGroups = await client.getProductGroups();
                } catch (error) {
                    useAlertStore().handleException(
                        i18n.global.t('publications.list.error.productGroups'),
                        error,
                        false
                    );
                }
            }

            this.loading = false;
            return this.productGroups;
        }
    }
});
